export default [
    {
        path: '/signatures/group-subscribers',
        name: 'signatures-group-subscribers',
        component: () => import ('./views/GroupSubscriberIndex'),
        meta: {
            title: 'Grupo de assinantes',
            icon: 'mdi-account-group',
            breadcrumbs: [
                { text: 'Lista de grupos assinantes', disabled: true }
            ]
        }
    },
]
